<script setup lang="ts">
/**
 * Error page for `ErrorCode.NoStateInAuthResponse` — no `state` parameter was
 * present in the OAuth callback. `state` carries the CSRF token generated
 * before the redirect; without it the CSRF check cannot be performed.
 * Delegates all rendering to `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.NoStateInAuthResponse" />
</template>
